import { i18n } from '@/plugins/i18n';

/**
 * Notification types constants.
 * Should remain identical as /server/.../NotifTypes.php
 */
export class NotificationType {
  // WARNING: Any new notification type must be added to the NotificationType table

  // NOTE: UPCOMING_MEETING is a client-only notification
  static UPCOMING_MEETING = new NotificationType(0, 'NOTIF_TITLE_UPCOMING_MEETING');

  static MEETING_STARTED = new NotificationType(1, 'NOTIF_TITLE_ONGOING_MEETING');

  static ACTION_ASSIGNED = new NotificationType(2, 'NOTIF_TITLE_NEW_SUPPORT_ACTION');

  static ACTION_COMPLETE = new NotificationType(3, 'NOTIF_TITLE_SUPPORT_ACTION_DONE');

  static PROBLEM_RECEIVED = new NotificationType(4, 'NOTIF_TITLE_PROBLEM_RECEIVED');

  static GW_STARTED = new NotificationType(5, 'NOTIF_TITLE_GW_STARTED');

  static INFO_RELEASED = new NotificationType(6, 'NOTIF_TITLE_INFO_RELEASED');

  /** Team A owns a problem, Team B revoked its own access */
  static PROBLEM_ACCESS_REVOKED = new NotificationType(7, 'NOTIF_TITLE_PB_ACCESS_REVOKED');

  /** Team A assigned an action to team B, team B returned it */
  static ACTION_RETURNED = new NotificationType(8, 'NOTIF_TITLE_ACTION_RETURNED');

  /** Specific user was assigned an action */
  static USER_ACTION_ASSIGNED = new NotificationType(
    9,
    'NOTIF_TITLE_USER_ACTION_ASSIGNED',
  );

  /** An action's deadline is overdue  */
  static USER_ACTION_DEADLINE_OVERDUE = new NotificationType(
    10,
    'NOTIF_TITLE_USER_ACTION_DEADLINE_OVERDUE',
  );

  /** An action's deadline is approaching  */
  static USER_ACTION_DEADLINE_APPROACHING = new NotificationType(
    11,
    'NOTIF_TITLE_USER_ACTION_DEADLINE_APPROACHING',
    'deadlineApproachDelay',
  );

  /** A comment has been added to a problem  */
  static PROBLEM_COMMENT = new NotificationType(12, 'NOTIF_TITLE_PROBLEM_COMMENT');

  /** Any update to a problem the user is subscribed to  */
  static PROBLEM_UPDATE = new NotificationType(13, 'NOTIF_TITLE_PROBLEM_UPDATE');

  id = -1;

  _titleTr = '';

  durationProperty = null;

  constructor(id, titleTr, durationProperty = null) {
    this.id = id;
    this._titleTr = titleTr;
    this.durationProperty = durationProperty;
  }

  getTitle(dataName) {
    return i18n.t(`message.${this._titleTr}`, { name: dataName });
  }
}

const typesPerId = {};
/* eslint-disable-next-line no-restricted-syntax */
for (const notifType in NotificationType) {
  if (notifType && NotificationType[notifType]) {
    typesPerId[`${NotificationType[notifType].id}`] = NotificationType[notifType];
  }
}
NotificationType.typesPerId = typesPerId;


export default {
  NotificationType,
};
